// import logo from './logo.svg';
// import './App.css';
import { createPortal } from 'react-dom';
import ScentSelector from './ScentSelector';

function ScentSelectorPortal(props) {
  return createPortal(
    <>
      {props.productTypes.map((productType, i) => (
        <>
          <ScentSelector {...props} 
            scents={props.getProducts(productType)}
            productType={productType.trim()}
            amountToSelect={Number(props.amountToSelect[i])}  
            size={props.sizes[i]}  
          />
        </>
      ))}
    </>,
    props.selector
  );
}

export default ScentSelectorPortal;
